export default function appViewerGlossaryIsOpen(state) {
  return state.appViewerGlossaryIsOpen;
}
